<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>assessment</mat-icon></div>
    <div class="tt-header-text">
      <h2 class="cf-dlg-title">Totalizar facturas simplificadas</h2>
      <p class="cf-dlg-subtitle">Suma las facturas simplificadas de un periodo y expórtalas a Excel</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="closeDialog()" [disabled]="busy" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <ng-container *ngIf="!busy; else busyTpl">
    <ng-container *ngIf="!result; else resultTpl">
      <div class="cf-dlg-body">
        <p class="tt-help">Elige el periodo que quieres totalizar.</p>
        <div class="tt-range">
          <mat-form-field appearance="outline" [class.cf-field--invalid]="submitted && !model.fromDate">
            <mat-label>Desde</mat-label>
            <input matInput [matDatepicker]="fromDate" [(ngModel)]="model.fromDate" name="fromDate" [max]="model.toDate">
            <mat-datepicker-toggle matSuffix [for]="fromDate"></mat-datepicker-toggle>
            <mat-datepicker #fromDate></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline" [class.cf-field--invalid]="submitted && !model.toDate">
            <mat-label>Hasta</mat-label>
            <input matInput [matDatepicker]="toDate" [(ngModel)]="model.toDate" name="toDate" [min]="model.fromDate">
            <mat-datepicker-toggle matSuffix [for]="toDate"></mat-datepicker-toggle>
            <mat-datepicker #toDate></mat-datepicker>
          </mat-form-field>
        </div>
        <p class="cf-field__error" *ngIf="submitted && (!model.fromDate || !model.toDate)">Indica las dos fechas del periodo.</p>
      </div>

      <div class="cf-dlg-footer">
        <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="closeDialog()">Cancelar</button>
        <button mat-flat-button class="cf-dlg-btn-primary" (click)="calculate()">
          <mat-icon>assessment</mat-icon> Totalizar
        </button>
      </div>
    </ng-container>

    <ng-template #resultTpl>
      <div class="cf-dlg-body">
        <div class="tt-range-summary">
          <span>Del <strong>{{ model.fromDate | date:'dd/MM/yyyy' }}</strong> al <strong>{{ model.toDate | date:'dd/MM/yyyy' }}</strong></span>
        </div>

        <ng-container *ngIf="tickets.length; else emptyTpl">
          <div class="tt-kpis">
            <div class="tt-kpi">
              <span class="tt-kpi__label">Facturas</span>
              <span class="tt-kpi__value">{{ tickets.length }}</span>
            </div>
            <div class="tt-kpi tt-kpi--highlight">
              <span class="tt-kpi__label">Total</span>
              <span class="tt-kpi__value">{{ total | number:'1.2-2' }} €</span>
            </div>
            <div class="tt-kpi">
              <span class="tt-kpi__label">Cobrado</span>
              <span class="tt-kpi__value tt-kpi__value--success">{{ paided | number:'1.2-2' }} €</span>
            </div>
            <div class="tt-kpi">
              <span class="tt-kpi__label">Pendiente</span>
              <span class="tt-kpi__value tt-kpi__value--warning">{{ total - paided | number:'1.2-2' }} €</span>
            </div>
          </div>

          <div class="tt-table-wrap">
            <table class="tt-table">
              <thead>
                <tr>
                  <th>Nº</th>
                  <th>Fecha</th>
                  <th>Cliente</th>
                  <th class="tt-num">Total</th>
                  <th>Cobro</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let t of tickets; trackBy: trackByUid">
                  <td>{{ t.ticketNumber }}</td>
                  <td>{{ t.date | date:'dd/MM/yyyy' }}</td>
                  <td>{{ t.receiverName || '—' }}</td>
                  <td class="tt-num">{{ t.total | number:'1.2-2' }} €</td>
                  <td>
                    <app-status-pill [label]="t.paided ? (t.paided | date:'dd/MM/yyyy') : 'Pendiente'" [variant]="t.paided ? 'success' : 'warning'"></app-status-pill>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>

        <ng-template #emptyTpl>
          <div class="tt-empty">
            <mat-icon>info</mat-icon>
            <span>No hay facturas simplificadas en este periodo.</span>
          </div>
        </ng-template>
      </div>

      <div class="cf-dlg-footer">
        <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="changeRange()">
          <mat-icon>date_range</mat-icon> Cambiar periodo
        </button>
        <button mat-flat-button class="cf-dlg-btn-primary" *ngIf="tickets.length" (click)="export()">
          <mat-icon>file_download</mat-icon> Exportar Excel
        </button>
      </div>
    </ng-template>
  </ng-container>

  <ng-template #busyTpl>
    <app-loading-state [message]="exporting ? 'Generando Excel…' : 'Totalizando facturas simplificadas…'"></app-loading-state>
  </ng-template>
</div>
